import { useGetEvents } from '../hooks';
import { InvitationsList } from './invitations-list';
import { InvitationsSkeleton } from './invitations-skeleton';

type P = {
  getPathToEventDetail: (id: string) => string;
};

const Invitations = ({ getPathToEventDetail }: P) => {
  const { events, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading, isRefetching } = useGetEvents({
    rsvp: ['pending' as const],
    status: 'published',
    type: 'upcoming',
  });

  if (isLoading || isRefetching || !events) {
    return <InvitationsSkeleton />;
  }

  return (
    <div className="calendar-invitations">
      <InvitationsList
        fetchNextPage={fetchNextPage}
        getPathToEventDetail={getPathToEventDetail}
        hasMoreData={hasNextPage}
        isFetching={isFetchingNextPage}
        items={events}
      />
    </div>
  );
};

export default Invitations;
